import { z } from 'zod';

/** Supported UI languages. Hebrew and Arabic are RTL. */
export const LocaleSchema = z.enum(['he', 'en', 'ru', 'fr', 'ar']);
export type Locale = z.infer<typeof LocaleSchema>;

export const RTL_LOCALES: ReadonlySet<Locale> = new Set<Locale>(['he', 'ar']);

/** All timestamps in the domain are JS millisecond epochs. */
export const TimestampSchema = z.number().int().nonnegative();
